export const DashboardIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M4 11l8-7 8 7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 10v10h12V10"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProfileIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect
      x={3}
      y={4}
      width={18}
      height={16}
      rx="2.4"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M7 9h10M7 13h6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const AddfundIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 5v14M5 12h14"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const BillersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M8 12h8M12 8v8"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const CaSingleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx={12} cy={8} r="3.4" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M5 20c1.5-4 4.2-6 7-6s5.5 2 7 6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M18 6v4M16 8h4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const CaBulkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3v12M7 10l5 5 5-5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const SavedCaIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M19 21l-7-4-7 4V5a2 2 0 012-2h10a2 2 0 012 2v16z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect
      x={3}
      y={5}
      width={18}
      height={16}
      rx="2.4"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M3 10h18M8 3v4M16 3v4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const ReviewIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M9 12l2 2 4-4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x={3}
      y={3}
      width={18}
      height={18}
      rx={3}
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </svg>
);

export const ApprovalIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M9 11l3 3L22 4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const ProcessingIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle
      cx={12}
      cy={12}
      r={9}
      stroke="currentColor"
      strokeWidth="1.8"
      strokeDasharray="4 3"
    />
  </svg>
);

export const SuccessIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M5 13l4 4L19 7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HistoryIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M12 7v5l3.5 2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const LedgerIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M4 4h16v16H4z" stroke="currentColor" strokeWidth="1.8" />
    <path d="M4 10h16M9 10v10" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

export const ReconIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M7 7h10M7 7l3-3M7 7l3 3M17 17H7M17 17l-3-3M17 17l-3 3"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReportsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M5 21V3h9l5 5v13z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M9 12h6M9 16h6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const NotificationsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SupportIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M9.5 9a2.5 2.5 0 015 .5c0 1.5-2.2 1.7-2.4 3.3"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <circle cx={12} cy="16.4" r="0.9" fill="currentColor" />
  </svg>
);
